import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  Grid,
  Typography,
  withStyles,
} from '@material-ui/core'
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
} from '@material-ui/icons'

import {
  editUser, getUser, getUserTransactions, getUserWallets,
  expireUserWallet,
} from '../actions/user'
import { LIST_TYPE, ROUTES } from '../constant'
import { ErrorText } from '../components/Text'
import { getAmountInfos } from '../helpers'
import Button from '../components/Button'
import Inline from '../components/Inline'
import ModalConfirm from '../components/ModalConfirm'
import Section from '../components/Section'
import Breadcrumb from '../components/Breadcrumb'
import ModalEditUser from '../components/ModalEditUser'
import TableAutomation from '../components/TableAutomation'


const styles = theme => ({
  root: {
    paddingTop: 0,
    padding: theme.spacing(1),
  },
  marginTop: {
    marginTop: theme.spacing(1),
  },
  preLine: {
    whiteSpace: 'pre-line',
  },
  content: {
    paddingBottom: theme.spacing(1),
  },
  section: {
    flex: 1,
    marginRight: theme.spacing(1),
  },
  sectionInfo: {
    width: 350,
  },
  flex1: {
    flex: 1,
  },
})


class User extends Component {
  /* LIFECYCLE */

  state = {
    walletId: '',
    modalOpened: false,
  }

  /**
   * @componentWillMount
   */
  componentWillMount() {
    const { uid } = this.props.match.params

    if (uid) {
      this.props.getUser(uid)
    }
  }

  /**
   * @componentDidUpdate
   * @param {*} prevProps - Previous properties of the Component
   */
  componentDidUpdate(prevProps) {
    const { item, match } = this.props
    const { uid } = match.params

    if (uid && uid !== prevProps.match.params.uid) {
      this.props.getUser(uid)
    }

    if (item && item.id !== (prevProps.item && prevProps.item.id)) {
      this.handleUserTransaction()
    }
  }


  /* METHODS */

  getRowByTransaction = (transaction) => {
    const row = []

    row.push(transaction.created_at ? moment(transaction.created_at).format('DD/MM/YYYY - HH:mm') : 'N/A')
    row.push({ data: transaction.shop.name || transaction.shop_id, display: transaction.shop_id ? <Link to={`${ROUTES.MARKET}/${transaction.shop_id}`}>{transaction.shop.name || transaction.shop_id}</Link> : transaction.shop.name })
    row.push(`${transaction.amount || 0} €`)

    if (transaction.error) {
      row.push({ data: transaction.error, display: <ErrorText>{transaction.error}</ErrorText> })
    } else if (transaction.expiration) {
      row.push({ data: 'expired', display: <ErrorText>Expired.</ErrorText> })
    } else if (transaction.success) {
      row.push({ data: 'OK !', display: <Typography color="secondary" variant="caption">OK !</Typography> })
    } else if (transaction.handled) {
      row.push({ data: transaction.error, display: <ErrorText>Echec</ErrorText> })
    } else {
      row.push({ data: 'pending', display: <Typography color="primary" variant="caption">En attente</Typography> })
    }

    return row
  }

  getRowByWallet = (wallet) => {
    const expiresAt = moment(wallet.expires_at.toDate())
    const isExpired = expiresAt.valueOf() < Date.now()
    const row = [
      `${wallet.available_amount} €`,
      `${wallet.initial_amount} €`,
      expiresAt.format('DD/MM/YYYY - HH:mm'),
    ]

    if (isExpired) {
      row.push({ data: 'expired', display: <ErrorText>Expired.</ErrorText> })
    } else {
      row.push({ data: 'OK !', display: <Typography color="secondary" variant="caption">OK !</Typography> })
    }

    row.push({
      data: 'action',
      display: !isExpired ? (
        <Button
          color="primary"
          variant="contained"
          onClick={() => this.handleOpenExpireWallet(wallet.id)}
        >
          <DeleteIcon />
        </Button>
      ) : <span />,
    })

    return row
  }

  handleOpenEditModal = () => this.setState({ modalOpened: 'edit' })

  handleOpenExpireWallet = (walletId) => this.setState({
    walletId,
    modalOpened: 'expire_wallet',
  })

  handleCloseModal = () => this.setState({ modalOpened: false })

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleUserTransaction = (options = {}) => {
    const { id } = this.props.item || {}

    if (id) {
      this.props.getUserTransactions(id, options)
    }
  }

  handleUserWallet = (options = {}) => {
    const { id } = this.props.item || {}

    if (id) {
      this.props.getUserWallets(id, options)
    }
  }

  handleSubmit = async (item) => {
    const response = await this.props.editUser(this.props.item.id, item)

    if (response) {
      this.handleCloseModal()
      this.handleUserTransaction()
    }
  }

  handleExpireWallet = async () => {
    if (this.state.walletId) {
      this.props.expireUserWallet(this.props.item.id, this.state.walletId)
    }

    this.handleCloseModal()
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      item,
      classes,
      isLoading,
    } = this.props
    const {
      modalOpened,
    } = this.state

    const transactions = (item && item.transactions) || {}
    const wallets = (item && item.walletList) || {}
    const { totalAmount, currentAmount } = getAmountInfos(item)

    return (
      <div className={classes.root}>
        <Breadcrumb
          data={[
            { label: 'Accueil', to: '/' },
            { label: 'Utilisateurs', to: ROUTES.USER },
            item ? `Utilisateur: ${item.email}` : 'Utilisateur',
          ]}
        />

        <Grid container direction="row" wrap="nowrap" className={classes.content}>
          <div className={classes.section}>
            <Section title="Wallets">
              {item && (
                <TableAutomation
                  disableMargin
                  {...wallets}
                  isLoading={isLoading}
                  row={this.getRowByWallet}
                  request={this.handleUserWallet}
                  head={['Montant', 'Montant initial', 'Expires le', 'Etat', 'Actions']}
                />
              )}
            </Section>

            <Section title="Historique des transactions">
              {item && (
                <TableAutomation
                  disableMargin
                  {...transactions}
                  isLoading={isLoading}
                  row={this.getRowByTransaction}
                  request={this.handleUserTransaction}
                  head={['Date', 'Commerce', 'Montant', 'Etat']}
                />
              )}
            </Section>
          </div>


          <Grid container direction="column" alignItems="center" className={classes.sectionInfo}>
            <Section title="Informations" className={classes.sectionInfo}>
              {item && (
                <>
                  <Inline>
                    <Typography>Téléphone: </Typography>
                    <Typography variant="caption">{item.phone}</Typography>
                  </Inline>
                  <Inline>
                    <Typography>Email: </Typography>
                    <Typography variant="caption">{item.email}</Typography>
                  </Inline>
                  <Inline>
                    <Typography>Montant:</Typography>
                    <Typography variant="caption"> {totalAmount} €</Typography>
                  </Inline>
                  <Inline>
                    <Typography>Solde restant:</Typography>
                    <Typography variant="caption"> {currentAmount} €</Typography>
                  </Inline>
                </>
              )}
            </Section>

            <Section title="Actions" className={classes.sectionInfo}>
              {item && (
                <>
                  <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    isLoading={isLoading}
                    onClick={this.handleOpenEditModal}
                  >
                    <EditIcon /><span className={classes.flex1}>Modifier</span>
                  </Button>
                </>
              )}
            </Section>
          </Grid>
        </Grid>

        {item && (
          <ModalEditUser
            user={item}
            isLoading={isLoading}
            open={modalOpened === 'edit'}
            onSubmit={this.handleSubmit}
            onClose={this.handleCloseModal}
          />
        )}

        {item && (
          <ModalConfirm
            isLoading={isLoading}
            submitLabel="Expirer le wallet"
            onClose={this.handleCloseModal}
            onSubmit={this.handleExpireWallet}
            open={modalOpened === 'expire_wallet'}
            title="Forcer l'expiration d'un wallet"
          >
            <Typography>Êtes-vous sûr de vouloir forcer l'expiration du solde de ce wallet ?<br />Le montant sera automatiquement affecté au compte Echo-Chèques</Typography>
          </ModalConfirm>
        )}
      </div>
    )
  }
}


User.propTypes = {
  item: PropTypes.object,
  match: PropTypes.object.isRequired,
  getUser: PropTypes.func.isRequired,
  editUser: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  getUserWallets: PropTypes.func.isRequired,
  expireUserWallet: PropTypes.func.isRequired,
  getUserTransactions: PropTypes.func.isRequired,
}


const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  item: state.item.type === LIST_TYPE.USERS ? state.item : null,
})


export default connect(mapStateToProps, {
  getUser,
  editUser,
  getUserWallets,
  expireUserWallet,
  getUserTransactions,
})(withStyles(styles)(User))
